import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TransportOption, TransportOptionCondition } from '../../transport-options.model';
import { TranslationService } from '@sdbn/common';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'yard-condition-assignments',
  standalone: false,
  templateUrl: './condition-assignments.component.html',
  styleUrl: './condition-assignments.component.scss',
})
export class ConditionAssignmentsComponent implements OnInit {

  transportOption: TransportOption;

  formGroup = new FormGroup({

  })

  @Input('transportOption') set setTransportOption(transportOption: TransportOption) {
    this.transportOption = transportOption;
  }

  conditions = new Array<TransportOptionCondition>();
  @Input('conditions') set setConditions(value: Array<TransportOptionCondition>) {
    this.conditions = value;
    const formGroup = new FormGroup({});
    for (const condition of value) {
      formGroup.addControl('condition_' + condition.id, new FormControl(false, []));
    }
    this.formGroup = formGroup;
  }

  @Output() changed = new EventEmitter();

  constructor(
    public translationService: TranslationService
  ) { }

  ngOnInit(): void {

    const values = {};
    for (const id of this.transportOption.conditionAssignments) {
      values['condition_' + id] = true;
    }

    this.formGroup.patchValue(values);

    this.formGroup.valueChanges.subscribe(values => {
      const ids = new Array<string>();
      for (const condition of this.conditions) {
        if (values['condition_' + condition.id]) {
          ids.push(condition.id);
        }
        this.transportOption.conditionAssignments = ids;
        this.changed.emit();
      }
    });

  }

}
